import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TextLimitedLength = props => {
  const { className = null, rootClassName = null, text, maxLength } = props;
  const classes = classNames(rootClassName, className);

  if (!text) return null;

  if (text.length <= maxLength) {
    return <p className={classes}>{text}</p>;
  }

  const truncatedText = text.slice(0, maxLength) + '...';

  return <p className={classes}>{truncatedText}</p>;
};

const { string, number } = PropTypes;

TextLimitedLength.propTypes = {
  rootClassName: string,
  className: string,
  text: string,
  maxLength: number,
};

// Default export
export default TextLimitedLength;
